/**
 * Load Data Pipeline — routes for the audit section.
 *
 * Its own router, mounted at /load-pipeline/*, so adding a page is a route
 * here rather than another entry in the app-level switch.
 *
 * ONE ENTRY PER THING IN THE PIPELINE: each writer, the topic, and each consumer. Market Intel used to be five sidebar entries for one
 * consumer, which read as five things rather than five views of one — they are
 * now tabs inside `/market-intel/:tab`. A second consumer, when one exists,
 * gets its own routed page the same way — not more tabs bolted onto this one.
 */

import { Navigate, Route, Routes } from 'react-router-dom'
import MarketIntelPage from './MarketIntelPage'
import OverviewPage from './OverviewPage'
import SearchPage from './SearchPage'
import TopicPage from './TopicPage'
import WriterPage from './WriterPage'

export default function LoadPipelineRoutes() {
    return (
        <Routes>
            <Route index element={<OverviewPage />} />
            <Route path="overview" element={<OverviewPage />} />

            {/* Writer */}
            <Route path="writer/dat" element={<WriterPage writer="dat" />} />
            <Route path="writer/sylectus" element={<WriterPage writer="sylectus" />} />
            <Route path="writer/parade" element={<WriterPage writer="parade" />} />
            <Route path="writer/usps" element={<WriterPage writer="usps" />} />
            <Route path="writer/boards" element={<WriterPage writer="boards" />} />
            <Route path="writer/ratecon" element={<WriterPage writer="ratecon" />} />
            <Route path="writer/broker-reply" element={<WriterPage writer="brokerReply" />} />
            {/* The note extractor is a consumer that publishes (ADR-049); its funnel is a writer's, so it reads as one. */}
            <Route path="notes" element={<WriterPage writer="notes" />} />
            <Route path="writer" element={<Navigate to="/load-pipeline/writer/dat" replace />} />

            {/* Topic */}
            <Route path="topic" element={<TopicPage />} />

            {/* Consumer — tabbed, so five views stay one entry */}
            <Route path="market-intel/:tab" element={<MarketIntelPage />} />
            <Route path="market-intel" element={<Navigate to="health" replace />} />

            {/* Consumer — load search (ADR-040), its own page */}
            <Route path="search/:tab" element={<SearchPage />} />
            <Route path="search" element={<Navigate to="probe" replace />} />
        </Routes>
    )
}
